import { getUserPreferencesForCurrentUser as getUserPreferencesForCurrentUserPlatform, } from 'src/platform/entities/user_preferences/user_preferences';
/**
 * Retrieves user preferences for the current user specific to platform.
 * @returns The platform-specific preferences object.
 */
export function getUserPreferencesForCurrentUser_platform() {
    return getUserPreferencesForCurrentUserPlatform('platform');
}
